import React from 'react';
export const SkeletonTable = ({ rows = 5, cols = 4 }) =>
	Array.from({ length: rows }).map((_, rowIndex) => (
		<tr key={rowIndex}>
			{Array.from({ length: cols }).map((_, colIndex) => (
				<td key={colIndex} className='p-3 border'>
					<div className='h-4 bg-gray-200 rounded animate-pulse'></div>
				</td>
			))}
		</tr>
	));
